<template>
    <v-container ma-0 pa-0>
        <!-- :disabled="get_FilteredHotels.length === 0" -->
        <v-combobox
            contenteditable="true"
            @dragenter="dragEnterHotelCombo()"
            @dragleave="dragLeaveHotelCombo()"
            @drop.prevent="dropHotelCombo()"
            v-bind:class="{ active: isActive }"

            v-model="hotel"
            :items="get_FilteredHotels"
            item-text="hotelname"
            item-value="hotelid"
            :return-object="true"

            :label="label"
            prepend-icon="mdi-bed"
            append-outer-icon="mdi-water"
            clearable
            chips>
        </v-combobox>
        <div style="margin-left: 33px; border-left: 1px solid #e6e6e6; padding-left: 8px;" v-html="completeHotel"></div>
    </v-container>
</template>


<script>
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'hotelscombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ Object, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> created');
            eventBus.$on('countrieschanged', this.onCountry_Changed);
            eventBus.$on('dragendhotelslist', this.onDragend_InSelectedHotelList);

        }, // eo created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> mounted');
            this.set_Hotel();

        }, // eo mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> beforeDestroy');
            eventBus.$off('countrieschanged', this.onCountry_Changed);
            eventBus.$off('dragendhotelslist', this.onDragend_InSelectedHotelList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                hotel               : null, // hotelObject => { hotelname: '', hotelid: '' }
                completeHotel       : null,
                // >>> --------------------------
                isActive            : false, // DnD highligt
                // >>> --------------------------
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            value() {

                this.set_Hotel();

            }, // eo value()

            hotel(value) {

                this.$emit('input', value);

            }, // eo hotel()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Hotels',
                'get_FilteredHotels', // get filtered list by countryid
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_filter_Hotels', // set: filter by countryid
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onCountry_Changed()
            *
            * Desc: Filter state::sharedHotelsResultsFiltered when
            * Desc: Countries have changed.
            * Note:
            *
            */
            onCountry_Changed: function(country) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> onCountry_Changed');
                this.hotel = null; // reset hotel
                this.actn_filter_Hotels(country.countryId);

            }, // eo function onCountry_Changed()


            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /*******************************************************************
            * onDragend_InSelectedHotelList()
            *
            * Desc:
            * Note: The small delay is necessary.
            *
            */
            onDragend_InSelectedHotelList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> onDragend_InSelectedHotelList');
                setTimeout(function() {
                    this.hotel = { hotelname: params.hotelName.trim() + ', ' + params.cityName, hotelid: params.hotelId };
                }.bind(this), 500);

            }, // eo function onDragend_InSelectedHotelList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * set_Hotel()
            *
            * Desc:
            * Note: Set 'completeHotel'.
            *
            */
            set_Hotel: function() {

                let me = this,
                    t = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> set_Hotel');
                me.hotel = this.value;

                if (me.hotel) {
                    t = this.get_HotelInfo(me.hotel);

                    me.completeHotel  = t.city + ': <strong>"' + t.hotelName + '"</strong> (' + t.hotelStars + ' Stars)<br />';
                    me.completeHotel += t.zipCode + ' ' + t.street + ' ' + t.streetNumber + '<br />';
                    me.completeHotel += t.phone + ', <a href="mailto:' + t.email + '">' + t.email + '</a><br />';
                    me.completeHotel += t.airportDistance !== null ? '<strong>Aprt(km):</strong> ' + t.airportDistance + ';' : '<strong>Aprt(km):</strong> no info; ';
                    me.completeHotel += t.airportTime !== null ? '<strong>Aprt(min):</strong> ' + t.airportTime + ';' : '<strong>Aprt(min):</strong> no info; ';
                    me.completeHotel += t.shuttleService !== null ? '<strong>Shuttle:</strong> ' + t.shuttleService + ';' : '<strong>Shuttle:</strong> no info;';
                } else {
                    me.completeHotel = null;
                }

            }, // eo function set_Hotel()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_HotelInfo()
            *
            * Desc: Return Hotel Info.
            * Note: hotelObject => { hotelname: '', hotelid: '' }
            *
            */
            get_HotelInfo: function(hotelObject) {

                let me = this,
                    hotelInfo = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/HotelsCombo.vue >>> get_HotelInfo');
                this.get_Hotels.forEach((hotel, i) => {
                    if (Number(hotel.id) === Number(hotelObject.hotelid)) {
                        hotelInfo = hotel;
                    }
                });


                return hotelInfo;

            }, // eo function get_HotelInfo()




            /******************************************************************* 'Listeners - DnD'
            * Drag&Drop (DnD):
            *******************************************************************/
            /*******************************************************************
            * dragEnterHotelCombo()
            *
            * Desc:
            * Note:
            *
            */
            dragEnterHotelCombo: function() {

                this.isActive = true;

            }, // eo function dragEnterHotelCombo()


            /*******************************************************************
            * dragLeaveHotelCombo()
            *
            * Desc:
            * Note:
            *
            */
            dragLeaveHotelCombo: function() {

                this.isActive = false;

            }, // eo function dragLeaveHotelCombo()


            /*******************************************************************
            * dropHotelCombo()
            *
            * Desc:
            * Note:
            * TODO: Some var = true in Case of droped?
            *
            */
            dropHotelCombo: function() {

                this.isActive = false;

            }, // eo function dropHotelCombo()


        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    /* DnD Background to highlight it */
    .active {
        background-color: #ab3b7a !important;
    }
</style>